import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TableModel } from 'src/app/models/table.model';
import { environment } from 'src/environments/environment';
import { PagedZohoBookBillDetail } from '../models/paged.zoho.book.bill.detail';
import { ZohoBookBillDtoModel } from '../models/zoho.book.bill.model';

@Injectable()
export class ZohoBookService {

    constructor(private http: HttpClient) { }

    list(tableModel: TableModel): Observable<PagedZohoBookBillDetail> {
        let url = `${environment.apiUrl}/api/photographer/zohoBookBill/list`;
        const queryParams = [];
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&');
        }
        return this.http.get<PagedZohoBookBillDetail>(url);
    }

    details(tableModel: TableModel, id: number): Observable<ZohoBookBillDtoModel> {
        let url = `${environment.apiUrl}/api/photographer/zohoBookBill/detail/${id}`;
        const queryParams = [];
        if (tableModel) {
            queryParams.push(tableModel.toQueryString());
        }
        if (queryParams.length) {
            url += '?' + queryParams.join('&');
        }
        return this.http.get<ZohoBookBillDtoModel>(url);
    }

    exportAsPdf(id: number) {
        return this.http.post(`${environment.apiUrl}/api/photographer/zohoBookBill/export-as-pdf/${id}`, {} , { responseType: 'blob' });
    }
}
